
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon50 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 58,
  preserveAspectRatio: "none",
  viewBox: "0 0 1200 1212"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M297.426 428.637c29.66 17.871 23.69 37.056 23.705 67.961l.022 70.18-.006 91.641c-.004 16.962.212 33.953-.532 50.872-.597 13.592-13.659 27.341-27.044 29.312-28.552 4.205-60.517-4.709-84.542-20.316-36.127-23.701-52.075-56.296-60.732-97.111a174.855 174.855 0 0 1 24.116-132.853 161.916 161.916 0 0 1 19.598-24.316c5.869-6.004 18.268-17.291 21.856-23.829 6.283-11.446 11.29-26.859 16.476-39.12a471.312 471.312 0 0 1 27.567-54.902c57.284-99.552 160.025-165.825 270.85-189.566 90.766-19.444 215.162 8.706 291.292 60.273 59.571 40.351 101.936 87.601 131.924 153.667 10.712 22.069 19.126 45.677 31.333 66.947 6.445 10.593 17.291 17.711 26.051 25.997 55.5 52.519 60 150.084 20.17 212.894-9.28 16.749-29.26 27.896-38.119 43.922-5.005 9.057-6.092 30.561-8.413 41.324C966.25 839.256 923.48 912.52 859.282 960.22c-15.661 11.636-31.062 22.571-50.279 26.531-20.017 5.142-61.238-7.246-72.912 7.103-12.313 15.136-17.567 25.696-34.997 38.656 31.379-44.198 39.093-66.447 18.413-118.716 8.951 11.825 13.817 24.608 29.786 25.784 33.32 2.452 54.089 1.328 80.861-19.528 54.393-42.373 93.672-111.478 104.451-179.094-58.325-.333-56.807-15.81-56.813-66.487l.021-53.569c.041-49.253-.031-98.507.096-147.759.05-19.732 4.13-34.572 23.8-42.844-25.383-74.446-91.022-140.234-160.949-174.595a319.686 319.686 0 0 0-243.756-15.532 329.11 329.11 0 0 0-190.31 167.845 507.655 507.655 0 0 0-9.268 20.622z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M701.094 1032.51c-31.055 26.69-64.431 36.52-104.924 27.09-51.664-12.57-89.916-67.834-77.186-120.497 17.828-73.751 100.706-103.875 163.905-65.363 16.78 10.224 26.654 23.39 36.618 40.054 20.68 52.269 12.966 74.518-18.413 118.716z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"58\" height=\"58\" preserveAspectRatio=\"none\"  viewBox=\"0 0 1200 1212\" id=\"732af2b9-6618-3258-895e-f9935c117c01\">\r\n  <path d=\"M 297.426 428.637 C 327.086 446.508 321.116 465.693 321.131 496.598 L 321.153 566.778 L 321.147 658.419 C 321.143 675.381 321.359 692.372 320.615 709.291 C 320.018 722.883 306.956 736.632 293.571 738.603 C 265.019 742.808 233.054 733.894 209.029 718.287 C 172.902 694.586 156.954 661.991 148.297 621.176 C 138.223 575.449 146.911 527.592 172.413 488.323 C 178.147 479.605 184.71 471.462 192.011 464.007 C 197.88 458.003 210.279 446.716 213.867 440.178 C 220.15 428.732 225.157 413.319 230.343 401.058 C 238.328 382.177 247.537 363.838 257.91 346.156 C 315.194 246.604 417.935 180.331 528.76 156.59 C 619.526 137.146 743.922 165.296 820.052 216.863 C 879.623 257.214 921.988 304.464 951.976 370.53 C 962.688 392.599 971.102 416.207 983.309 437.477 C 989.754 448.07 1000.6 455.188 1009.36 463.474 C 1064.86 515.993 1069.36 613.558 1029.53 676.368 C 1020.25 693.117 1000.27 704.264 991.411 720.29 C 986.406 729.347 985.319 750.851 982.998 761.614 C 966.25 839.256 923.48 912.52 859.282 960.22 C 843.621 971.856 828.22 982.791 809.003 986.751 C 788.986 991.893 747.765 979.505 736.091 993.854 C 723.778 1008.99 718.524 1019.55 701.094 1032.51 C 732.473 988.312 740.187 966.063 719.507 913.794 C 728.458 925.619 733.324 938.402 749.293 939.578 C 782.613 942.03 803.382 940.906 830.154 920.05 C 884.547 877.677 923.826 808.572 934.605 740.956 C 876.28 740.623 877.798 725.146 877.792 674.469 L 877.813 620.9 C 877.854 571.647 877.782 522.393 877.909 473.141 C 877.959 453.409 882.039 438.569 901.709 430.297 C 876.326 355.851 810.687 290.063 740.76 255.702 C 664.767 218.466 577.109 212.88 497.004 240.17 C 413.682 268.43 345.145 328.877 306.694 408.015 C 303.452 414.819 300.362 421.695 297.426 428.637 z\"></path>\r\n  <path fill=\"var(--theme-primary, #810ea9)\" d=\"M 701.094 1032.51 C 670.039 1059.2 636.663 1069.03 596.17 1059.6 C 544.506 1047.03 506.254 991.766 518.984 939.103 C 536.812 865.352 619.69 835.228 682.889 873.74 C 699.669 883.964 709.543 897.13 719.507 913.794 C 740.187 966.063 732.473 988.312 701.094 1032.51 z\"></path>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-50.04b3400e68104e74b14870f81008ce1e.svg"),
        {
          React: SvgIcon50,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      